import styled from 'styled-components';

export default styled.p`
font-size: 0.8em;
${props => props.center && 'text-align: center'}
`
